import { render, staticRenderFns } from "./qr_code_normal.vue?vue&type=template&id=501fd2e9&"
import script from "./qr_code_normal.vue?vue&type=script&lang=ts&"
export * from "./qr_code_normal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VIcon,VToolbar})
